<template lang="html">
  <div class="draft-room">
    <section class="picks">
      <draft-picks />
    </section>

    <section class="clock">
      <draft-clock />
    </section>

    <section class="selected">
      <draft-selected />
    </section>

    <section class="roster">
      <draft-current-roster />
    </section>

    <draft-admin />
    <draft-selected-modal />
    <draft-payment-block />
    <draft-board-help-modal ref="draftBoardHelpModal" />
    <draft-mobile />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import DraftPicks from './DraftPicks';
import DraftSelected from './DraftSelected';
import DraftClock from './DraftClock';
import DraftCurrentRoster from './DraftCurrentRoster';

import DraftAdmin from './DraftAdmin';
import DraftSelectedModal from './DraftSelectedModal';
import DraftBoardHelpModal from './DraftBoardHelpModal';
import DraftPaymentBlock from './DraftPaymentBlock';
import DraftMobile from './DraftMobile';

export default {
  components: {
    DraftPicks,
    DraftSelected,
    DraftClock,
    DraftCurrentRoster,
    DraftAdmin,
    DraftSelectedModal,
    DraftBoardHelpModal,
    DraftPaymentBlock,
    DraftMobile,
  },

  computed: {
    ...mapState({
      id: ({ route }) => route.params.id,
      draft: ({ draft }) => draft.draft,
      seenDraftBoardHelp: ({ draft }) => draft.seenDraftBoardHelp,
    }),

    ...mapGetters({
      isDraftComplete: 'draft/isDraftComplete',
    }),
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.isDraftComplete) {
        next(`/draft/${vm.id}/review`);
      }
    });
  },
  watch: {
    isDraftComplete(value) {
      if (value) {
        setTimeout(() => {
          this.$store.dispatch('draft/COMPLETE_DRAFT');
          this.$router.push(`/draft/${this.id}/review?startSlideshow=true`);
        }, 5000);
      }
    },
  },

  mounted() {
    document.addEventListener('webkitfullscreenchange', () => {
      this.$store.commit('draft/SET_FULL_SCREEN', document.webkitIsFullScreen);
    });

    document.addEventListener('fullscreenchange', () => {
      this.$store.commit('draft/SET_FULL_SCREEN', document.fullscreen);
    });

    document.addEventListener('mozfullscreenchange', () => {
      this.$store.commit('draft/SET_FULL_SCREEN', document.mozFullScreen);
    });

    document.addEventListener('MSwebkitfullscreenchange', () => {
      this.$store.commit('draft/SET_FULL_SCREEN', document.webkitIsFullScreen);
    });

    if (!this.seenDraftBoardHelp) {
      this.$refs.draftBoardHelpModal.open();
      this.$store.commit('draft/SET_DRAFT_BOARD_HELP');
    }
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .draft-room {
    display: grid;
    height: 100vh;
    width: 100vw;
    grid-template-columns: px-to-rem(360px) 1fr auto;
    grid-template-rows: auto 1fr;
  }

  .picks {
    background-color: $dark-color;
    grid-column: 1;
    grid-row: 1 / span 2;
  }

  .clock {
    background-color: $dark-color-active;
    grid-column: 2;
    grid-row: 1;
  }

  .selected {
    grid-column: 3;
    grid-row: 1;
    width: px-to-rem(390px);
  }

  .roster {
    background-color: $dark-color;
    grid-column: 2 / span 2;
    grid-row: 2;
  }
</style>
